import {Button, ButtonDropdown, icon, TextRegular} from '@hm/fundamental'
import React, {useCallback, useState} from 'react'

import {SortByColumn, SortDirection} from '../../types'

export interface SamplingPointsMobileSortingProps {
  sortByLabel: string
  samplingPointCodeLabel: string
  samplingPointCountsLabel: string
  sortBy: SortByColumn
  sortDirection: SortDirection
  onToggleSorting: (column: SortByColumn) => void
}

export const SamplingPointsMobileSorting: React.FC<SamplingPointsMobileSortingProps> = ({
  sortByLabel,
  samplingPointCodeLabel,
  samplingPointCountsLabel,
  sortBy,
  sortDirection,
  onToggleSorting
}) => {
  const [isMobileSortDropdownOpen, setIsMobileSortDropdownOpen] = useState(false)

  const handleMobileCodeSorting = useCallback(() => {
    onToggleSorting(SortByColumn.CODE)
    setIsMobileSortDropdownOpen(false)
  }, [onToggleSorting])

  const handleMobileCountSorting = useCallback(() => {
    onToggleSorting(SortByColumn.COUNTS)
    setIsMobileSortDropdownOpen(false)
  }, [onToggleSorting])

  const handleMobileSortDropdownToggle = useCallback(() => {
    setIsMobileSortDropdownOpen((isOpen) => !isOpen)
  }, [])

  const closeMobileSortDropdown = useCallback(() => {
    setIsMobileSortDropdownOpen(false)
  }, [])

  return (
    <div className="relative flex justify-start mb-2 p-1">
      <ButtonDropdown
        variant="secondary"
        icon={icon.mdiSort}
        rightOnClick={handleMobileSortDropdownToggle}
        data-test-id="sampling_points_table_mobile_sort_toggle"
        className="rounded border border-gray-300 bg-white [&>button]:!border-gray-300 [&>button]:!bg-white"
      >
        {sortByLabel}
      </ButtonDropdown>

      {isMobileSortDropdownOpen && (
        <>
          <Button
            variant="secondary"
            aria-label="close-sort-dropdown"
            data-test-id="sampling_points_table_mobile_sort_backdrop"
            onClick={closeMobileSortDropdown}
            className="fixed inset-0 z-40 border-0 bg-transparent p-0"
          />

          <div
            data-test-id="sampling_points_table_mobile_sort_dropdown"
            className="absolute left-2 top-full z-50 mt-1 rounded border border-gray-300 bg-white shadow-md"
          >
            <Button
              variant="secondary"
              data-test-id="sampling_points_table_mobile_sort_by_code"
              onClick={handleMobileCodeSorting}
              className="flex items-center gap-2 w-full border-0 bg-white px-3 py-2 cursor-pointer text-left"
            >
              <TextRegular>{samplingPointCodeLabel}</TextRegular>
              <TextRegular>
                {sortBy === SortByColumn.CODE
                  ? sortDirection === SortDirection.ASCENDING
                    ? '↑'
                    : '↓'
                  : ''}
              </TextRegular>
            </Button>
            <Button
              variant="secondary"
              data-test-id="sampling_points_table_mobile_sort_by_counts"
              onClick={handleMobileCountSorting}
              className="flex items-center gap-2 w-full border-0 bg-white px-3 py-2 cursor-pointer text-left"
            >
              <TextRegular>{samplingPointCountsLabel}</TextRegular>
              <TextRegular>
                {sortBy === SortByColumn.COUNTS
                  ? sortDirection === SortDirection.ASCENDING
                    ? '↑'
                    : '↓'
                  : ''}
              </TextRegular>
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
